import { z } from 'zod';

import { parseOrThrow } from '../../../api';

export const passwordChangeResultSchema = z.object({
  success: z.boolean(),
  code: z.string().nullish(),
  message: z.string().default(''),
});

export const languageSavedSchema = z.object({
  success: z.boolean(),
  message: z.string().default(''),
});

export { parseOrThrow };
